<template>
  <div style="padding-top: 10px">
    <span v-if="isLoadding" style="height: 100px">
      <v-container
        fill-height
        fluid
        :style="
          display === 'Desktop'
            ? 'height: ' + (heightDisplay - 325) + 'px;'
            : 'height: ' + (heightDisplay - 150) + 'px;'
        "
      >
        <v-row align="center" justify="center">
          <v-col
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
            class="text-center"
            ><h1 style="font-size: 48px">
              <span style="color: #3F44A3">Kan</span>
              <span style="color: #4A98B2">Pramool</span>
            </h1>
          </v-col>
          <v-col
            class="text-center"
            sm="10"
            md="6"
            cols="8"
            xl="3"
            xs="10"
            lg="3"
            ><v-progress-linear
              color="#F8F364"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear
          ></v-col>
        </v-row>
      </v-container>
    </span>

    <v-form v-model="valid" v-if="isdata">
      <v-container>
        <v-dialog v-model="dialog1" persistent max-width="1000" class="theme">
          <v-card>
            <v-img src="../assets/moph.gif" height="20%" dark> </v-img>
          </v-card>
        </v-dialog>
        <v-card class="mx-auto" max-width="1000">
          <v-img src="../assets/3156482.jpg" height="150px"> </v-img>
          <v-row class="Format2">
            <v-col cols="12" sm="5" md="5" class="Format">
              <b>E-Mail พนักงาน</b>
              <v-text-field
                placeholder="E-Mail พนักงาน"
                type="text"
                dense
                shaped
                v-model="form.email"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="7" md="7" class="Format">
              <b>ชื่อพนักงาน</b>
              <v-text-field
                placeholder="ชื่อพนักงาน"
                type="text"
                dense
                v-model="form.fullname"
                outlined
                shaped
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="Format2">
            <v-col cols="12" sm="5" md="5" class="Format">
              <b>username</b>
              <v-text-field
                placeholder="username"
                type="text"
                dense
                shaped
                v-model="form.username"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="7" md="7" class="Format">
              <b>password</b>
              <v-text-field
                placeholder="password"
                type="text"
                dense
                v-model="form.password"
                outlined
                shaped
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-center">
                <v-btn
                  style="width: 422px"
                  rounded
                  color="success"
                  :disabled="!valid"
                  @click="onSubmit"
                  >เพิ่มข้อมูลพนักงาน</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-form>
  </div>
</template>
<script>
// import axios from "axios";
import md5 from "crypto-js/md5";
export default {
  data() {
    return {
      isLoadding: null,
      isdata: null,
      display: null,
      valid: null,
      dialog1: null,
      form: {
        email: null,
        login_type: "KanPramool",
        username: null,
        role: "Operation",
        fullname: null,
        password: null,
        password_md5: null,
        created_by: localStorage.getItem("username"),
      },
    };
  },

  mounted() {
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/login");
      }
      //----------
    }
    this.checkHightDisplay();
    this.loaddingPage();
    // this.$axios
    //   .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
    //   .then((res) => {
    //     if (!res.data.status) {
    //       alert("เวอรันที่ใช้งานไม่ตรงกับเวอร์ชันปัจจุบัน");
    //       location.reload();
    //     }
    //   });
    if (localStorage.getItem("username") === undefined) {
      alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
      this.$router.push("/login");
    }
  },
  methods: {
    onSubmit() {
      let md5Hash = md5(this.password);
      this.form.password_md5 = md5Hash.toString();
      // console.log(this.form);
      this.$axios.post(this.api + "/post/user", this.form).then((res) => {
        if (res.data.status) {
          alert("คุณได้สมัครเรียบร้อยเเล้ว กรุณารอการตรวจสอบ");
          location.reload();
        } else {
          if (res.data.error === "Duplicate") {
            alert(
              "คุณเคยสมัครไว้เเล้ว ไม่สามารถสมัครซ้ำได้ กรุณารอการตอบกลับจากทีมงาน"
            );
          } else {
            alert("ไม่สามารถสมัครได้ กรุณาติดต่อทีมงาน");
          }
        }
      });
    },
    checkHightDisplay() {
      this.heightDisplay = screen.height;
    },

    loaddingPage() {
      this.isLoadding = true;
      setTimeout(() => (this.isLoadding = false), 3000);
      setTimeout(() => (this.dialog = !false), 3000);
      setTimeout(() => (this.isdata = !false), 3000);
    },
    loaddingPageadd() {
      this.isLoadding = true;
      setTimeout(() => (this.isLoadding = false), 6000);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
.theme {
  background: #f1fff4;
}
.home-page {
  padding-top: 0px;
  padding-bottom: 0px;
}

.Format {
  padding-top: 0px;
  padding-left: 20px;
  padding-right: 20px;
}
.Format2 {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.inputOrderIn {
  font-size: 30px;
  font-weight: bold;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
